import React, {Component} from "react";
import UpdateOrderBorrower from "./UpdateOrderBorrowerView";
import {CatalogDateService} from "../../../../service/catalog/CatalogDateService";
import {OrderBorrowerService} from "../../../../service/ptt/OrderBorrowerService";
import {Growl} from "primereact/growl";

export default class UpdateOrderBorrowerContainer extends Component {
    constructor(props) {
        super(props);

        this.catalogDateService = new CatalogDateService();
        this.orderBorrowerService = new OrderBorrowerService();


        this.getMaturityDate = this.getMaturityDate.bind(this);
        this.editOrderBorrower = this.editOrderBorrower.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveDataOrderBorrower = this.saveDataOrderBorrower.bind(this);

        this.state = {
            isLoading: false,
            returnPath: this.props.location.state.returnPath,
            orderBorrower: this.props.location.state.orderBorrower,
            maturityDate: this.getMaturityDate(),
        };


    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    handleReturnButton() {
        this.props.history.push({
            pathname: this.state.returnPath,
        });
    }

    getMaturityDate() {
        if (this.props.location.state.orderBorrower.plazo !== undefined
            && this.props.location.state.orderBorrower.fecValor !== undefined) {
            this.loading();
            this.catalogDateService.getMaturityDate(
                this.props.location.state.orderBorrower.plazo,
                this.props.location.state.orderBorrower.fecValor
            ).then(
                maturityDate => {
                    this.setState({
                        maturityDate: maturityDate[0],
                    })
                });
        }
    }

    saveDataOrderBorrower(event) {
        const {name, value} = event.target;
        let orderBorrower = this.state.orderBorrower;
        orderBorrower[name] = value;
        this.setState({orderBorrower: orderBorrower,})
    }

    editOrderBorrower() {
        let cantidad = this.state.orderBorrower.cantidad;

        if (cantidad === undefined || cantidad === '' || cantidad * 1 <= 0) {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Favor de validar la cantidad"});
            return;
        }

        this.loading();
        this.orderBorrowerService.editOrderBorrower(
            this.state.orderBorrower.folio,
            cantidad
        ).then(
            this.props.history.push({
                pathname: this.state.returnPath,
            })
        );
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <UpdateOrderBorrower
            messagesGrowl={messagesGrowl}
            isLoading={this.state.isLoading}
            orderBorrower={this.state.orderBorrower}
            handleReturnButton={this.handleReturnButton}
            saveDataOrderBorrower={this.saveDataOrderBorrower}
            maturityDate={this.state.maturityDate}
            editOrderBorrower={this.editOrderBorrower}
        />
    }
}